interface GhostButtonProps {
  children: React.ReactNode
}

export function GhostButton({children}: GhostButtonProps) {
  return (
    <button className="px-3.5 py-2 rounded-xl border border-border-light text-muted hover:text-ink hover:border-glow transition">
      {children}
    </button>
  )
}
